var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.switchClass,on:{"click":_vm.toggle}},[_c('span',{class:`${_vm.prefixCls}__inner`},[(_vm.value)?_c('span',[_vm._v("True")]):_vm._e(),(!_vm.value)?_c('span',[_vm._v("False")]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }